import { QuoteDeclarationSearchRequestQuery, QuoteDeclarationSearchResponse } from '@lio/api-types';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { config } from '@services/config';
import { quoteDeclarationQueryKeys } from './keys';
import { getQuoteDeclarationQuery } from './helpers';

export const useSearchQuoteDeclarations = (quoteId: string, params: QuoteDeclarationSearchRequestQuery) => {
  const client = useClient();

  const queryParams = getQuoteDeclarationQuery(params);

  const result = useQuery<QuoteDeclarationSearchResponse, Error>({
    ...config,
    queryKey: quoteDeclarationQueryKeys.searchWithParams(quoteId, params),
    queryFn: () =>
      client.get(`quote/${quoteId}/quote-declaration?${queryParams}`).json<QuoteDeclarationSearchResponse>(),
    enabled: true,
  });

  return { ...result, items: result.data || [] };
};
